import React from 'react';
import CustomRoutes from '@routes/Routes';
import { BrowserRouter } from 'react-router-dom';
import { notification } from 'antd';
import { NotificationProvider } from '@providers/NotificationProviders';
import * as styles from '@styles/app.module.scss';
import 'antd/dist/reset.css';

// React component on ts
const App: React.FC = () => {
  const [api, contextHolder] = notification.useNotification();
  return (
      <NotificationProvider api={api}>
        <section className={styles.body}>
          {contextHolder}
          <BrowserRouter>
              <CustomRoutes />
          </BrowserRouter>
        </section>
      </NotificationProvider>
  );
};

export default App;
